import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentQuestion: 1,
  // timeLeft: 1920, // Default time for a module (31:25 in seconds)
  // isTimerHidden: false,
  selectedAnswer: null,
  totalQuestions: 27, // Default value; will be updated dynamically
  // isMoreOptionsOpen: false,
  // strikedOptions: [],
  // isAbcMode: false,
  // isHelpModalOpen: false,
  // isDirectionsModalOpen: true,
  // isShortcutsModalOpen: false,
  // isQuestionOverviewOpen: false,
  answeredQuestions: {},
  // markedQuestions: [],
  isReviewMode: false,
  // isExitModalOpen: false,
  // isCalculatorOpen: false,
  // calculator: null,
  // calculatorWindow: null,
  currentSection: 1,
  currentModule: 1,
  // isModuleComplete: false,
  isBreakTime: false,
  // isLoading: false,
  questionData: {}, // Will store fetched questions
};

const ExamSlice = createSlice({
  name: "exam",
  initialState,
  reducers: {
    nextQuestion: (state) => {
      if (state.currentQuestion < state.totalQuestions) {
        state.currentQuestion += 1;
        state.selectedAnswer = null;
      } else {
        state.isReviewMode = true;
      }
    },
    prevQuestion: (state) => {
      if (state.currentQuestion > 1) {
        state.currentQuestion -= 1;
        state.selectedAnswer = null;
      }
    },
    setQuestion: (state, action) => {
      state.currentQuestion = action.payload;
      state.selectedAnswer = null;
    },
    selectAnswer: (state, action) => {
      state.selectedAnswer = action.payload;
    },
    setAnsweredQuestions: (state, action) => {
      const { section, module, question, answer } = action.payload;
      // Ensure section exists
      if (!state.answeredQuestions[section]) {
        state.answeredQuestions[section] = {};
      }

      // Ensure module exists
      if (!state.answeredQuestions[section][module]) {
        state.answeredQuestions[section][module] = {};
      }

      const previousTime =
        state.answeredQuestions[section][module]?.[question]?.timeTaken || 0;

      // Update the answer for the specific question
      state.answeredQuestions[section][module][question] = {
        ans: answer.ans,
        timeTaken: (
          parseFloat(previousTime) + parseFloat(answer.timeTaken)
        ).toFixed(2),
      };
    },

    // markForReview: (state) => {
    //   if (state.markedQuestions.includes(state.currentQuestion)) {
    //     state.markedQuestions = state.markedQuestions.filter(
    //       (q) => q !== state.currentQuestion
    //     );
    //   } else {
    //     state.markedQuestions.push(state.currentQuestion);
    //   }
    // },

    updateQuestionData: (state, action) => {
      state.questionData = action.payload;
      state.totalQuestions = action.payload?.questions?.length || 0;
    },
    setIsBreakTime: (state, action) => {
      state.isBreakTime = action.payload;
    },
    setReviewMode: (state, action) => {
      state.isReviewMode = action.payload;
    },
    setSection: (state, action) => {
      state.currentSection = action.payload;
    },
    setModule: (state, action) => {
      state.currentModule = action.payload;
    },
    resetExam: () => initialState,
  },
});

export const {
  nextQuestion,
  prevQuestion,
  setQuestion,
  setReviewMode,
  selectAnswer,
  setAnsweredQuestions,
  updateQuestionData,
  setIsBreakTime,
  setSection,
  setModule,
  resetExam,
} = ExamSlice.actions;

export default ExamSlice.reducer;
